module.exports = __webpack_public_path__ + "static/media/ehealth_survey_banner_desktop.488b5d6b.png";